import React, { useContext } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { AuthContext } from "../contexts/AuthProvider";
import useAdmin from "../hooks/useAdmin";
import useBuyer from "../hooks/useBuyer";
import useSeller from "../hooks/useSeller";
import { FaBars } from "react-icons/fa";
import Navbar from "../Pages/Shared/Navbar/Navbar";

const DashboardLayout = () => {
  const { user } = useContext(AuthContext);

  const [isBuyer, isBuyerLoading] = useBuyer(user?.email);
  const [isSeller, isSellerLoading] = useSeller(user?.email);
  const [isAdmin, isAdminLoading] = useAdmin(user?.email);

  let activeStyle = {
    fontSize: "18px",
    fontWeight: "700",
    color: "#22d3ee",
    backgroundColor: "#1f2937",
  };

  return (
    <div>
      <Navbar />
      <div className="drawer drawer-mobile">
        <input
          id="dashboard-drawer"
          type="checkbox"
          className="drawer-toggle"
        />
        <div className="drawer-content">
          <label
            htmlFor="dashboard-drawer"
            tabIndex={0}
            className="lg:hidden flex justify-end mt-[5px] mr-2"
          >
            <div className="flex justify-center items-center gap-2 mr-1">
              <span
                className="text-[21.5px] font-semibold text-cyan-700 mb-[2px]
               md:mb-[0px]"
              >
                D Menu
              </span>
              <span>
                <FaBars className="h-[22px] w-[20px] text-blue-600 cursor-pointer" />
              </span>
            </div>
          </label>
          <Outlet />
        </div>
        <div className="drawer-side">
          <label htmlFor="dashboard-drawer" className="drawer-overlay"></label>
          <ul className="menu p-4 w-[240px] bg-gray-800 text-white">
            {isBuyerLoading ? (
              <div className="flex justify-center items-center h-[100vh]">
                <ScaleLoader color="#20c9e7" height={20} />
              </div>
            ) : (
              <div>
                {isBuyer && (
                  <div>
                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/myorders"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        My Bookings
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/mywishlist"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        My WishList
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/my-reported-items"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        My Reported Phones
                      </NavLink>
                    </li>
                  </div>
                )}
              </div>
            )}

            {isSellerLoading ? (
              <div className="flex justify-center items-center h-[100vh]">
                <ScaleLoader color="#20c9e7" height={20} />
              </div>
            ) : (
              <div>
                {isSeller && (
                  <div>
                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/addproduct"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        Add A Phone
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/myproducts"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        My Phones
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/mybuyers"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        My Buyers
                      </NavLink>
                    </li>
                  </div>
                )}
              </div>
            )}

            {isAdminLoading ? (
              <div className="flex justify-center items-center h-[100vh]">
                <ScaleLoader color="#20c9e7" height={20} />
              </div>
            ) : (
              <div>
                {isAdmin && (
                  <div>
                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/manageallusers"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        Manage All Users
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/allproducts"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        All Phones
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/alladmins"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        All Admins
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/allsellers"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        All Sellers
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/allbuyers"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        All Buyers
                      </NavLink>
                    </li>

                    <li className="text-[17px] hover:text-[19px] hover:text-lg font-semibold hover:text-fuchsia-300 hover:font-bold">
                      <NavLink
                        to="/dashboard/reporteditems"
                        style={({ isActive }) =>
                          isActive ? activeStyle : undefined
                        }
                      >
                        All Reported Phones
                      </NavLink>
                    </li>
                  </div>
                )}
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
